/* global document */

// This stub defines a clickOutside directive, reusable across components if
// need be.

// This custom directive adds the ability for triggers to occur on clicks
// outside of an element.  Based on this SO answer:
//   https://stackoverflow.com/a/42389266

// USAGE:
//
// In the template -
//   <div v-click-outside="clickedOutside"></div>
//
// And in the same component, define a method to do whatever you need -
//   method: {
//     clickedOutside() {
//       // Whatever!
//     }
//   }

export var clickOutside = {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
    document.body.addEventListener("touchend", el.clickOutsideEvent);
  },
  unbind: function (el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
    document.body.removeEventListener("touchend", el.clickOutsideEvent);
  }
};



// WEBPACK FOOTER //
// ./src/frontend/common/click-outside.js